/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import Link from "@material-ui/core/Link";
import {useSelector} from "react-redux";

export function AsideMenuList({ layoutProps }) {
  const {
    user
  } = useSelector((state) => ({
    user: state.auth.user,
  }));

  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

 // console.log(user);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Dashboard */}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/* Device */}
          <li className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/Devices",
            true  )}`} aria-haspopup="true" data-menu-toggle="hover" >
          <NavLink className="menu-link menu-toggle" to="/device">
          <span className="svg-icon menu-icon">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")}/>
          </span>
          <span className="menu-text">Devices</span>
          </NavLink>
          <div className="menu-submenu">
          <i className="menu-arrow"/>
          <ul className="menu-subnav">
          <li className="menu-item menu-item-parent" aria-haspopup="true">
          <span className="menu-link">
          <span className="menu-text">Devices</span>
          </span>
          </li>
          <li
          className={`menu-item ${getMenuItemActive("/device")}`}
          aria-haspopup="true"
          >
          <NavLink className="menu-link" to="/device">
          <i className="menu-bullet menu-bullet-dot">
          <span/>
          </i>
          <span className="menu-text">List of Devices</span>
          </NavLink>
          </li>
          <li
          className={`menu-item ${getMenuItemActive("/device/discovering")}`}
          aria-haspopup="true"
          >
          <NavLink className="menu-link" to="/device/discovering">
          <i className="menu-bullet menu-bullet-dot">
          <span/>
          </i>
          <span className="menu-text">List of Discovering Devices</span>
          </NavLink>
          </li>

          </ul>
          </div>
          </li>
        {/* Account */}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/Accounts",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/account">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")} />
            </span>
            <span className="menu-text">Accounts</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Accounts</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/account")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/account">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">List of Accounts</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
        {/* SiteMaps */}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/sitemap",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/sitemap">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")} />
            </span>
            <span className="menu-text">SiteMap</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">SiteMap</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/sitemap/houses")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/sitemap/houses/list">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Houses</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/sitemap/house/")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/sitemap/house/0/floor/list">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Floor/Rooms</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
        {/* Configurations */}
        <li
          className={`menu-item ${getMenuItemActive("/configurations", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/configurations">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Configurations</span>
          </NavLink>
        </li>
        {/* Scenes/Automations */}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/automation",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/automation">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")} />
            </span>
            <span className="menu-text">Automation</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Automation</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/automation/list")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/automation/list">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">List of Scene/Automations</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/automation/new")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/automation/new">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Add Scene/Automations</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
        {/* Manufacturer */}
        <li
          className={`menu-item ${getMenuItemActive("/manufacturer", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/manufacturer">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Manufacturers</span>
          </NavLink>
        </li>
        {/* Settings */}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/settings",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/settings">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")} />
            </span>
            <span className="menu-text">Settings</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Settings</span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/settings/backup")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/settings/backup">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Back-up Data</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/settings/restore"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/settings/restore">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Restore Data</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/settings/factory-reset"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/settings/factory-reset">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">Factory Reset</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
        {/* Update */}
        <li
          className={`menu-item ${getMenuItemActive("/update", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/update">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Update</span>
          </NavLink>
        </li>

        {/* Update */}
        <li
          className={`menu-item ${getMenuItemActive("/accesscontrol", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/accesscontrol">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Access Control</span>
          </NavLink>
        </li>
        {/*<li  className={`menu-item`}>*/}

        {/*  <Link target={"_blank"} className="menu-link" rel={"noopener noreferrer"}  href={"http://"+window.location.hostname+":4200"}>*/}
        {/*    <span className="svg-icon menu-icon">*/}
        {/*      <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />*/}
        {/*    </span>*/}
        {/*    <span className="menu-text">Fall Detect</span>*/}
        {/*  </Link>*/}
        {/*</li>*/}

        {/* Settings */}
        {/*<li*/}
        {/*  className={`menu-item menu-item-submenu ${getMenuItemActive(*/}
        {/*    "/development",*/}
        {/*    true*/}
        {/*  )}`}*/}
        {/*  aria-haspopup="true"*/}
        {/*  data-menu-toggle="hover"*/}
        {/*>*/}
        {/*  <NavLink className="menu-link menu-toggle" to="/development">*/}
        {/*    <span className="svg-icon menu-icon">*/}
        {/*      <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")} />*/}
        {/*    </span>*/}
        {/*    <span className="menu-text">Development</span>*/}
        {/*  </NavLink>*/}
          {/*<div className="menu-submenu">*/}
          {/*  <i className="menu-arrow" />*/}
          {/*  <ul className="menu-subnav">*/}
          {/*    <li className="menu-item menu-item-parent" aria-haspopup="true">*/}
          {/*      <span className="menu-link">*/}
          {/*        <span className="menu-text">Development</span>*/}
          {/*      </span>*/}
          {/*    </li>*/}
          {/*    <li*/}
          {/*      className={`menu-item ${getMenuItemActive(*/}
          {/*        "/development/devices"*/}
          {/*      )}`}*/}
          {/*      aria-haspopup="true"*/}
          {/*    >*/}
          {/*      <NavLink className="menu-link" to="/development/devices">*/}
          {/*        <i className="menu-bullet menu-bullet-dot">*/}
          {/*          <span />*/}
          {/*        </i>*/}
          {/*        <span className="menu-text">Devices</span>*/}
          {/*      </NavLink>*/}
          {/*    </li>*/}
          {/*    <li*/}
          {/*      className={`menu-item ${getMenuItemActive(*/}
          {/*        "/development/automations"*/}
          {/*      )}`}*/}
          {/*      aria-haspopup="true"*/}
          {/*    >*/}
          {/*      <NavLink className="menu-link" to="/development/automations">*/}
          {/*        <i className="menu-bullet menu-bullet-dot">*/}
          {/*          <span />*/}
          {/*        </i>*/}
          {/*        <span className="menu-text">Automations</span>*/}
          {/*      </NavLink>*/}
          {/*    </li>*/}
          {/*  </ul>*/}
          {/*</div>*/}
        {/*</li>*/}

      </ul>
    </>
  );
}
